import { useActivePhoto, useSetActivePhoto } from '@context/ActivePhotoContext'
import Image from 'next/image'
import fullPhoto from '@utils/links/fullPhoto'

import styles from 'styles/Thumbnails.module.css'

const Thumbnails = ({ offer, alt = '', fallback }) => {
    const pid = offer?.tracking?.pid
    const photos = offer?.photos

    if (!pid || !Array.isArray(photos)) return null

    const currentActivePhoto = useActivePhoto()
    const setActivePhoto = useSetActivePhoto()

    const changePhoto = ({currentTarget:el}) => setActivePhoto(el.getAttribute('order'))
    return (
        <div className={styles.wrapper}>
            {
                photos.map(order => (
                    <div
                        order={order}
                        key={order}
                        className={styles.thumb}
                        onClick={order !== currentActivePhoto
                            ? changePhoto
                            : undefined}>

                        <Image
                            alt={alt}
                            fallback={fallback}
                            height={92}
                            src={fullPhoto(pid, order)}
                            width={140} />
                    </div>
                ))
            }
        </div>
    )
}

export default Thumbnails